<template>
  <div>
    <v-container fluid>
      <h5>ข้อมูลคะแนนโหวต</h5>
      <div v-if="!loading" style="margin: auto" :key="barchartkey">
        <div id="chart">
          <apexchart type="bar" height="400" :options="chartOptions" :series="series"></apexchart>
        </div>
        <div>
          <v-card>
            <v-card-text>
              <v-layout row wrap>
                <v-flex xs6>
                  <div class="text-xs-center" style="font-weight: bold; color: grey">
                    คะแนนโหวตทั้งหมด
                  </div>
                  <div
                    class="text-xs-center"
                    style="font-weight: bold; color: #0057f5; font-size: 19px"
                  >
                    {{ votedata.total }}
                  </div>
                </v-flex>
                <v-flex xs6>
                  <div class="text-xs-center" style="font-weight: bold; color: grey">
                    จำนวนคนโหวตทั้งหมด
                  </div>
                  <div
                    class="text-xs-center"
                    style="font-weight: bold; color: #0057f5; font-size: 19px"
                  >
                    {{ votedata.total_user }}
                  </div>
                </v-flex>
              </v-layout>
            </v-card-text>
          </v-card>
        </div>
        <div>
          <v-card>
            <v-card-text>
              <v-layout row wrap>
                <v-flex xs12 md4 class="pr-3">
                  <apexchart
                    width="100%"
                    type="pie"
                    :options="chartOptionsAge"
                    :series="seriesAge"
                  ></apexchart
                ></v-flex>
                <v-flex xs12 md4 class="pr-3">
                  <apexchart
                    type="pie"
                    width="100%"
                    :options="chartOptionsGender"
                    :series="seriesGender"
                  ></apexchart>
                </v-flex>
                <v-flex xs12 md4 class="pr-3">
                  <apexchart
                    type="pie"
                    width="100%"
                    :options="chartOptionsProvince"
                    :series="seriesProvince"
                  ></apexchart>
                </v-flex>
              </v-layout>
            </v-card-text>
          </v-card>
        </div>
      </div>
      <div v-else>
        <dashboard-graph-loading></dashboard-graph-loading>
      </div>
    </v-container>
    <v-dialog v-model="popupmodal" persistent max-width="900px">
      <div>
        <v-card>
          <div v-if="popuploading" class="text-xs-center" style="padding: 50px">
            <v-progress-circular indeterminate color="primary" :size="50"></v-progress-circular>
          </div>
          <div v-else>
            <div class="text-xs-right">
              <v-btn @click="closePopup" icon>
                <v-icon>close</v-icon>
              </v-btn>
            </div>
            <div style="border-bottom: 1px solid #e5e5e5">
              <v-layout row wrap>
                <v-flex xs6>
                  <div class="text-xs-center" style="font-weight: bold; color: grey">
                    คะแนนโหวตทั้งหมด
                  </div>
                  <div
                    class="text-xs-center"
                    style="font-weight: bold; color: #0057f5; font-size: 19px"
                  >
                    {{ dialogData.total }}
                  </div>
                </v-flex>
                <v-flex xs6>
                  <div class="text-xs-center" style="font-weight: bold; color: grey">
                    จำนวนคนโหวตทั้งหมด
                  </div>
                  <div
                    class="text-xs-center"
                    style="font-weight: bold; color: #0057f5; font-size: 19px"
                  >
                    {{ dialogData.total_user }}
                  </div>
                </v-flex>
              </v-layout>
            </div>
            <v-card-text>
              <v-layout row wrap>
                <v-flex xs12 md4>
                  <apexchart
                    type="pie"
                    :options="chartOptionsPopupAge"
                    :series="seriesPopupAge"
                  ></apexchart
                ></v-flex>
                <v-flex xs12 md4>
                  <apexchart
                    type="pie"
                    :options="chartOptionsPopupGender"
                    :series="seriesPopupGender"
                  ></apexchart>
                </v-flex>
                <v-flex xs12 md4>
                  <apexchart
                    type="pie"
                    :options="chartOptionsPopupProvince"
                    :series="seriesPopupProvince"
                  ></apexchart>
                </v-flex>
              </v-layout>
              <div>
                <v-data-table
                  expand
                  style="position: relative; bottom: 50px"
                  v-bind:pagination.sync="commentPagination"
                  :headers="headers"
                  :rows-per-page-items="[10, 25, 45, { text: $t('All'), value: -1 }]"
                  :rows-per-page-text="$t('Rows per page')"
                  :items="dialogData.userlist"
                  class="elevation-1 scgallrenttable"
                >
                  <template v-slot:items="props">
                    <tr>
                      <!-- <td class="text-xs-center">{{ props.item.productid }}</td> -->
                      <td class="text-xs-center">{{ props.item.name }}</td>
                      <td class="text-xs-center">
                        {{ props.item.vote_date | dateFormat('DD/MM/YYYY HH:mm') }}
                      </td>
                    </tr>
                  </template>
                </v-data-table>
              </div>
            </v-card-text>
          </div>
        </v-card>
      </div>
    </v-dialog>
  </div>
</template>

<script>
import api from '@/api'
import DateFilter from './DateFilter.vue'
import { mapGetters } from 'vuex'
import moment from 'moment'
import apexchart from 'vue-apexcharts'
import DashboardGraphLoading from './DashboardGraphLoading'
import collect from 'collect.js'

export default {
  components: {
    DateFilter,
    apexchart,
    DashboardGraphLoading,
  },
  data() {
    return {
      votedata: '',
      commentPagination: { sortBy: 'value', descending: true, rowsPerPage: 10 },
      headers: [
        {
          align: 'center',
          text: this.$t('ชื่อ'),
          value: 'name',
        },
        {
          align: 'center',
          text: this.$t('วันที่โหวต'),
          value: 'vote_date',
        },
      ],
      barchartkey: '',
      loading: true,
      popuploading: false,
      popupmodal: false,
      totaluserSeries: [],
      dialogData: {},
      seriesGender: [],
      seriesAge: [],
      seriesProvince: [],
      seriesPopupGender: [],
      seriesPopupAge: [],
      seriesPopupProvince: [],
      series: [
        {
          name: 'vote',
          data: [],
        },
      ],
      chartOptions: {
        title: {
          text: 'คะแนนโหวต',
          align: 'center',
          style: {
            fontSize: '18px',
            fontWeight: 'bold',
            fontFamily: 'Roboto',
            color: 'grey',
          },
        },
        chart: {
          events: {
            dataPointSelection: this.barclick,
          },
          height: 650,
          width: '100%',
          type: 'bar',
        },
        theme: {
          palette: 'palette1', // upto palette10
        },
        plotOptions: {
          bar: {
            distributed: true,
            dataLabels: {
              position: 'right', // top, center, bottom
            },
          },
        },
        dataLabels: {
          enabled: true,
          formatter: function (val) {
            return val
          },
          offsetY: -20,
          style: {
            fontSize: '12px',
            colors: ['#304758'],
          },
        },

        xaxis: {
          categories: [],
          position: 'bottom',
          axisBorder: {
            show: false,
          },
          axisTicks: {
            show: false,
          },
          crosshairs: {
            fill: {
              colors: ['#F44336', '#E91E63', '#9C27B0'],
            },
          },
          tooltip: {
            enabled: true,
          },
        },
        yaxis: {
          axisBorder: {
            show: false,
          },
          axisTicks: {
            show: false,
          },
        },
      },
      chartOptionsPopupGender: {
        legend: {
          position: 'right',
          horizontalAlign: 'right',
          width: 140,
          offsetY: 20,
          floating: true,
        },
        plotOptions: {
          pie: {
            size: 60,
            offsetX: -50,
          },
        },
        title: {
          text: 'แยกตามเพศ',
          align: 'center',
          style: {
            fontSize: '18px',
            fontWeight: 'bold',
            fontFamily: 'Roboto',
            color: 'grey',
          },
        },
        chart: {
          width: '100%',
          type: 'pie',
        },
        labels: ['ผู้ชาย', 'ผู้หญิง'],
      },
      chartOptionsPopupAge: {
        legend: {
          position: 'right',
          horizontalAlign: 'right',
          width: 140,
          offsetY: 20,
          floating: true,
        },
        plotOptions: {
          pie: {
            size: 60,
            offsetX: -50,
          },
        },
        title: {
          text: 'แยกตามอายุ',
          align: 'center',
          style: {
            fontSize: '18px',
            fontWeight: 'bold',
            fontFamily: 'Roboto',
            color: 'grey',
          },
        },
        chart: {
          width: '100%',
          type: 'pie',
        },
        labels: [],
      },
      chartOptionsPopupProvince: {
        legend: {
          position: 'right',
          horizontalAlign: 'right',
          width: 140,
          offsetY: 20,
          floating: true,
        },
        plotOptions: {
          pie: {
            size: 60,
            offsetX: -50,
          },
        },
        title: {
          text: 'แยกตามจังหวัด',
          align: 'center',
          style: {
            fontSize: '18px',
            fontWeight: 'bold',
            fontFamily: 'Roboto',
            color: 'grey',
          },
        },
        chart: {
          width: '100%',
          type: 'pie',
        },
        labels: [],
      },
      chartOptionsAge: {
        legend: {
          position: 'right',
          horizontalAlign: 'right',
          width: 140,
          offsetY: 20,
          floating: true,
        },
        plotOptions: {
          pie: {
            offsetX: -50,
            size: 80,
          },
        },
        title: {
          text: 'แยกตามอายุ',
          align: 'center',
          style: {
            fontSize: '18px',
            fontWeight: 'bold',
            fontFamily: 'Roboto',
            color: 'grey',
          },
        },
        chart: {
          width: '100%',
          type: 'pie',
        },
        labels: [],
      },
      chartOptionsGender: {
        legend: {
          position: 'right',
          horizontalAlign: 'right',
          width: 140,
          offsetY: 20,
          floating: true,
        },
        plotOptions: {
          pie: {
            offsetX: -50,
            size: 80,
          },
        },
        title: {
          text: 'แยกตามเพศ',
          align: 'center',
          style: {
            fontSize: '18px',
            fontWeight: 'bold',
            fontFamily: 'Roboto',
            color: 'grey',
          },
        },
        chart: {
          width: '100%',

          type: 'pie',
        },
        labels: [],
      },
      chartOptionsProvince: {
        legend: {
          position: 'right',
          horizontalAlign: 'right',
          width: 140,
          offsetY: 20,
          floating: true,
        },
        plotOptions: {
          pie: {
            offsetX: -50,
            size: 80,
          },
        },
        title: {
          style: {
            fontSize: '18px',
            fontWeight: 'bold',
            fontFamily: 'Roboto',
            color: 'grey',
          },
          text: 'แยกตามจังหวัด',
          align: 'center',
        },
        chart: {
          width: '100%',

          type: 'pie',
        },
        labels: [],
      },

      selectedDate: {
        start: moment().format('YYYY-MM-DD HH:mm'),
        end: moment().format('YYYY-MM-DD HH:mm'),
      },
      data: [],
    }
  },
  computed: {
    ...mapGetters(['selectedBot']),
  },
  mounted() {
    this.getData()
  },
  methods: {
    closePopup() {
      this.popupmodal = false
    },
    barclick(e, a, item) {
      this.getCompetitor(this.chartOptions.xaxis.categories[item.dataPointIndex])
    },
    getCompetitor(id) {
      var vm = this
      vm.popupmodal = true
      vm.popuploading = true
      api.superjeewrankedvotingBycompetitorid(
        {
          pageid: vm.selectedBot.pageid,
          competitorid: id,
        },
        (err, response) => {
          if (response.responsecode == 200 && response.data) {
            vm.dialogData = response.data[0]
            const collection = collect(vm.dialogData.ages)
            const collectionGender = collect(vm.dialogData.gender)
            const collectionprovince = collect(vm.dialogData.province)
            var agesvalue = collection.values().all()
            var ageskey = collection
              .keys()
              .all()
              .map((el) => el + ' ปี')
            vm.chartOptionsPopupAge.labels = ageskey
            vm.seriesPopupAge = agesvalue

            var gendervalue = collectionGender.values().all()
            var genderkey = collectionGender
              .keys()
              .all()
              .map((el) => el)
            vm.chartOptionsPopupGender.labels = genderkey
            vm.seriesPopupGender = gendervalue

            var provincevalue = collectionprovince.values().all()
            var provincekey = collectionprovince
              .keys()
              .all()
              .map((el) => el)
            vm.chartOptionsPopupProvince.labels = provincekey
            vm.seriesPopupProvince = provincevalue
          }
          vm.popuploading = false
        }
      )
    },
    getData() {
      var vm = this
      api.superjeewrankedvoting(
        {
          pageid: vm.selectedBot.pageid,
          datefrom: '2020-01-01',
          dateto: '2021-12-31',
        },
        (err, response) => {
          if (response.responsecode == 200) {
            this.votedata = response.data[0]
            const collection = collect(response.data[0].competitor)
            const collectionAge = collect(response.data[0].ages)
            const collectionGender = collect(response.data[0].gender)
            const collectionProvince = collect(response.data[0].province)
            this.series[0].data = collection.values().all()
            this.chartOptions.xaxis.categories = collection.keys().all()
            var agesvalue = collectionAge.values().all()
            var ageskey = collectionAge
              .keys()
              .all()
              .map((el) => el + ' ปี')
            vm.chartOptionsAge.labels = ageskey
            vm.seriesAge = agesvalue

            var gendervalue = collectionGender.values().all()
            var genderkey = collectionGender
              .keys()
              .all()
              .map((el) => el)
            vm.chartOptionsGender.labels = genderkey
            vm.seriesGender = gendervalue

            var provincevalue = collectionProvince.values().all()
            var provincekey = collectionProvince
              .keys()
              .all()
              .map((el) => el)
            vm.chartOptionsProvince.labels = provincekey
            vm.seriesProvince = provincevalue

            this.barchartkey = new Date().getTime()
            this.loading = false
          }
        }
      )
    },
    onDateChanged() {
      this.getData()
    },
  },
}
</script>

<style lang="scss" scoped>
</style>


// WEBPACK FOOTER //
// src/components/view/dashboard/SupertenDashboard.vue